import PropTypes from 'prop-types';
import React from 'react';

import { ProcModal } from '@sonyged/ext-proc';

export default class TitleModal extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.timeoutId = setTimeout(() => {
      this.props.onNext();
    }, this.props.timeout);
  }

  render() {
    return (
      <ProcModal rootNodeId={this.props.rootNodeId} isOpened={true}>
        <div key="modal" className={'proc-modal menu'}>
          <div className={'modal-contents'}>
            <div className={'title-container'}>
              <div className={'title secondary20-color proc-medium-font'}>{this.props.title}</div>
              <div className={'desc white-color proc-huge-font'}>{this.props.subTitle}</div>
            </div>
          </div>
        </div>
      </ProcModal>
    );
  }
}

TitleModal.propTypes = {
  exitLink: PropTypes.string,
  query: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  rootNodeId: PropTypes.string,
  timeout: PropTypes.number,
  onNext: PropTypes.func,
};

TitleModal.defaultProps = {
  rootNodeId: 'proc-page-root',
  timeout: 2000,
  className: '',
  exitLink: '/',
  query: '',
  onNext: () => {},
  style: {},
};
